<div *ngIf="shouldBeDisplayed" class="row">
    <div
        *ngIf="appliedFilters.length > 0 || searchInfo"
        class="filters selenium-results-filters col-xs-12 col-sm-12 col-md-12 col-lg-12"
    >
        <a
            *ngIf="searchInfo"
            class="filter selenium-results-filter"
            title="{{ searchInfo.title }}"
            [ngStyle]="{
                'background-color': searchInfo.colors.mainColor,
                'border-color': searchInfo.colors.mainColor
            }"
            (click)="onClearCollectionFilter()"
        >
            {{ searchInfo.title | safeTruncate: 100 }}<span class="close-symbol">&times;</span>
        </a>
        <a
            *ngFor="let filter of appliedFilters"
            class="filter selenium-results-filter"
            title="{{ filter.title }}"
            [ngClass]="{ inactive: !filter.active }"
            (click)="onClearFilter(filter.filter)"
        >
            {{ filter.title | safeTruncate: 100 }}<span class="close-symbol">&times;</span>
        </a>
        <a
            class="filter clear selenium-results-clear-filters gtm-clear-filters"
            (click)="onClearAllFilters()"
        >
            Clear Filters <i class="fas fa-trash"></i>
        </a>
    </div>
</div>
